/**
 * Debug logging system. Stores logs in memory and exposes via window.__debug.
 */
const MAX_LOGS = 500;

class _DebugLog {
  constructor() {
    this.logs = [];
    this.enabled = true;
  }

  _add(level, system, message) {
    const entry = {
      time: Date.now(),
      level,
      system,
      message,
    };
    this.logs.push(entry);
    if (this.logs.length > MAX_LOGS) {
      this.logs.shift();
    }
    if (this.enabled) {
      const prefix = `[${system}]`;
      if (level === 'error') console.error(prefix, message);
      else if (level === 'warn') console.warn(prefix, message);
      else console.log(prefix, message);
    }
  }

  info(system, message) { this._add('info', system, message); }
  warn(system, message) { this._add('warn', system, message); }
  error(system, message) { this._add('error', system, message); }

  getLogs(filter) {
    if (!filter) return [...this.logs];
    return this.logs.filter(l =>
      l.system.includes(filter) || l.message.includes(filter)
    );
  }

  clear() {
    this.logs = [];
  }
}

export const DebugLog = new _DebugLog();
